/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IGrupoActividadEconomica from 'Infotrack@Modelos/administracion/grupoActividadEconomica/entidades/grupoActividadEconomica';
import React from 'react';
import GrupoActividadEconomicaCM from '../controladorModelo/grupoActividadEconomicaCM';
import { acciones, IEstadoGrupoActividadEconomica } from '../reductorGrupoActividadEconomica';
import GrupoActividadEconomicaVista from '../vista/tablaGrupoActividadEconomicaVista';

const grupoActividadEconomicaCM = new GrupoActividadEconomicaCM();

const TableGrupoActividadEconomicaCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [grupoActividadEconomicas, setGrupoActividadEconomicas] = React.useState<IGrupoActividadEconomica[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoGrupoActividadEconomica>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarGrupoActividadEconomica();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarGrupoActividadEconomica = () => {
        manejadorIndicadorCargaGlobal(true);
        grupoActividadEconomicaCM.consultarGrupoActividadEconomica().then((grupoActividadEconomicas) => {
            setGrupoActividadEconomicas(grupoActividadEconomicas);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (
        tipoFormulario: TipoFormulario,
        entidadGrupoActividadEconomica?: IGrupoActividadEconomica
    ) => {
        dispatch({
            type: acciones.CAMBIAR_ESTADO_FORMULARIO,
            payload: { entidadGrupoActividadEconomica, tipoFormulario },
        });
    };

    const confirmarEliminacion = (grupoActividadEconomica: IGrupoActividadEconomica) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarGrupoActividadEconomica(grupoActividadEconomica),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarGrupoActividadEconomica = (grupoActividadEconomica: IGrupoActividadEconomica) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        grupoActividadEconomicaCM.eliminarGrupoActividadEconomica(grupoActividadEconomica).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <GrupoActividadEconomicaVista
            grupoActividadEconomicas={grupoActividadEconomicas}
            cargarGrupoActividadEconomica={cargarGrupoActividadEconomica}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableGrupoActividadEconomicaCV;
